import { AnnotatedTriStateProgressBar } from 'edrolo-style-guide';
import style from './TeacherQuestionItem.scss';
import pluralize from 'pluralize';
import { number, any } from 'prop-types';

export const TeacherQuestionItem = ({
  questionId,
  classQuestionSetAggregates,
}) => {
  pluralize.addIrregularRule('needs', 'need');

  const totalUnderstood = classQuestionSetAggregates.getIn([
    `${questionId}`,
    'total_responded_understood',
  ]);

  const totalNeedHelp = classQuestionSetAggregates.getIn([
    `${questionId}`,
    'total_responded_need_help',
  ]);

  const totalNotReflected =
    classQuestionSetAggregates.getIn([`${questionId}`, 'profile_count']) -
    classQuestionSetAggregates.getIn([`${questionId}`, 'total_completed']);

  return (
    <AnnotatedTriStateProgressBar
      negativeCount={totalNeedHelp}
      nullCount={totalNotReflected}
      positiveCount={totalUnderstood}
      order={['negative', 'positive', 'null']}
      allowZero
    >
      <span>
        <span className={style.semibold}>{`${totalNeedHelp}`} </span>
        {pluralize('needs', totalNeedHelp)} help
      </span>
    </AnnotatedTriStateProgressBar>
  );
};

TeacherQuestionItem.propTypes = {
  questionId: number,
  classQuestionSetAggregates: any,
};
